import * as React from 'react';

const IconAccounting = () => <img src="https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-9919532/images/accounting/icon-accounting.svg" alt="" />;

export default IconAccounting;
